import { GET_HISTORY_LOGS } from '_modules/history-logs/actions'

export const getHistoryLogsSelector = state =>
  state?.historyLogs?.get('results')?.valueSeq().toArray()

export const getHistoryLogsLoadingSelector = state => !!state.loading.get(GET_HISTORY_LOGS.ACTION)

export const getEventsFilter = state => state?.historyLogs?.get('filter')
